import { render, staticRenderFns } from "./management-config-parameter-form.vue?vue&type=template&id=1aabfbb6&"
import script from "./management-config-parameter-form.vue?vue&type=script&lang=js&"
export * from "./management-config-parameter-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports